module.exports = __webpack_public_path__ + "img/bonnie-logo.4d0fafaa.jpg";